import React from "react";
import Tag from "../../../../generic/tag";
import "../../../../../assets/scss/components/toc/orderBook/instruments/instrumentsMob.scss";
import { ChipColorKeyComb } from "../../obConstants";
export interface IObAssetsDetlSymMobProps {
	date?: string;
	trsTyp: string;
	title?: string;
	subTitle?: string;
	sts: string;
}

const ObAssetsDetlSymMob: React.FC<IObAssetsDetlSymMobProps> = props => {
	return (
		<div className="ob_ast_detls_mob_con">
			<div className="tag_con ib">
				<Tag value={props.trsTyp} color={props.trsTyp === "BUY" ? "green" : "red"} shape="circle" height="60px" width="60px" />
			</div>
			<div className="asst_dtl">
				<h2 className="comp ">{props.title}</h2>
				<p className="symb">{props.subTitle}</p>
				<div className="sts_con">
					<div className="date">{props.date}</div>
					<div className="tag_con">
						<Tag value={props.sts} shape="chip" color={ChipColorKeyComb[props.sts]} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ObAssetsDetlSymMob;
